/**
 * Parses a `Cookie`/`document.cookie` header string (`name=value; name2=value2`)
 * into a Map. Values are returned verbatim (no URI decoding) — decoding is the
 * caller's responsibility, matching the previous raw (non-decoded) cookie reads.
 * Last occurrence of a name wins.
 */
export function parseCookieHeader(raw: string): Map<string, string> {
  const out = new Map<string, string>()
  for (const part of raw.split(';')) {
    const eq = part.indexOf('=')
    if (eq === -1) continue
    const name = part.slice(0, eq).trim()
    if (!name) continue
    let value = part.slice(eq + 1).trim()
    if (value.length >= 2 && value.startsWith('"') && value.endsWith('"')) {
      value = value.slice(1, -1)
    }
    out.set(name, value)
  }
  return out
}
